<template>
  <chart-card
    :chart-data="revenueChart"
    :chart-options="revenueChart.options"
    chart-type="Bar"
    :chart-height="175"
  >
    <template slot="header">
      <h4 class="card-title">Gesamtumsatz pro Tag</h4>
      <p class="card-category">Umsatz in €</p>
    </template>
    <template slot="filter-content">
      <table-filter
        :filterComponents="[
          {
            type: 'DateRangeFilter',
            name: 'whereDate',
            attributes: { dateField: 'paid_at' }
          }
        ]"
        v-model="filter"
        @apply-filters="$bus.$emit('refresh-table')"
        :autoApply="true"
      ></table-filter>
    </template>
    <template slot="footer">
      <hr />
      <div class="stats">
        <i class="fa fa-history"></i> Letzte {{ daysToShow }} Tage
      </div>
    </template>
  </chart-card>
</template>

<script>
import ChartCard from "src/components/UIComponents/Cards/ChartCard";
import { brightenHex } from "src/components/UIComponents/Charts/utils";
import { getDateFormattedLocal } from "@/js/date";
import { formatCurrency } from "@/js/currency";

import moment from "moment";

export default {
  components: {
    ChartCard
  },
  data() {
    return {
      dates: [],
      daysToShow: 31,
      revenueChart: {
        labels: [],
        datasets: [],
        options: {
          tooltips: {
            enabled: true,
            callbacks: {
              label: (tooltipItem, data) => {
                let amount =
                  data.datasets[tooltipItem.datasetIndex].data[
                    tooltipItem.index
                  ];

                return "Umsatz: " + formatCurrency(amount);
              }
            }
          }
        }
      },
      filter: [
        {
          name: "whereDate",
          attributes: [
            {
              column: "paid_at",
              operator: "<=",
              value: moment()
                .endOf("day")
                .format("YYYY-MM-DD")
            },
            {
              column: "paid_at",
              operator: ">=",
              value: moment()
                .startOf("day")
                .subtract(31, "day")
                .format("YYYY-MM-DD")
            }
          ]
        }
      ]
    };
  },
  methods: {
    setupDays() {
      const diffDays = Math.abs(
        moment
          .duration(
            moment(this.filter[0].attributes[1].value).diff(
              moment(this.filter[0].attributes[0].value)
            )
          )
          .asDays()
      );
      this.dates = [];
      for (let i = 0; i < diffDays; i++) {
        let date = new Date();
        date.setDate(
          new Date(this.filter[0].attributes[0].value).getDate() - i
        );
        date.setHours(0, 0, 0, 0);
        this.dates.push(date);
      }
    },
    setupDayLabels() {
      let dayLabels = this.dates.map(date => {
        return getDateFormattedLocal(date);
      });

      this.revenueChart.labels = dayLabels;
    },
    setupStartofMonth() {
      this.revenueChart.options.lineAtValue = this.startOfMonth();
    },

    startOfMonth() {
      let dates = [];
      this.dates.forEach(function(item) {
        if (
          moment(item.getTime())
            .startOf("month")
            .format("YYYY-MM-DD") ===
          moment(item.getTime())
            .startOf("day")
            .format("YYYY-MM-DD")
        ) {
          dates.push(getDateFormattedLocal(item));
        }
      });
      return dates;
    },

    setupDatasets() {
      this.$http
        .get("/api/v1/transaction/dailyIncome", {
          params: { filter: this.filter }
        })
        .then(({ data }) => {
          let datasets = [];
          let currentMonth = null;
          let currentDataset = null;

          this.dates.forEach((date, index) => {
            if (date.getMonth() !== currentMonth) {
              currentMonth = date.getMonth();
              let color =
                "#" +
                ((currentMonth + 1) * 123456789)
                  .toString(16)
                  .slice(2, 8)
                  .padStart(6, "0");

              let hoverColor = brightenHex(color, 15);

              currentDataset = {
                label: "Umsatz",
                borderColor: color,
                fill: true,
                backgroundColor: color,
                hoverBorderColor: hoverColor,
                hoverBackgroundColor: hoverColor,
                borderWidth: 5,
                data: []
              };

              // Add 0 for all dates already in previous datasets
              for (let i = 0; i < index; i++) {
                currentDataset.data.push(0);
              }
              datasets.push(currentDataset);
            }

            currentDataset.data.push(
              data[moment(date.getTime()).format("YYYY-MM-DD")]
            );
          });

          this.revenueChart.datasets = datasets;
        });
    }
  },
  created() {
    this.setupDays();
    this.setupDayLabels();
    this.setupDatasets();
    this.setupStartofMonth();
  },
  watch: {
    filter() {
      this.setupDays();
      this.setupStartofMonth();
      this.setupDayLabels();
      this.setupDatasets();
    }
  }
};
</script>
